import { render, staticRenderFns } from "./ExamenesListAux.vue?vue&type=template&id=85f8e02a"
import script from "./ExamenesListAux.vue?vue&type=script&lang=js"
export * from "./ExamenesListAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports